// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IGetQuestionsWebRequestSchema {
  /** Загрузить все вопросы? **/
  getAllItems?: boolean | null;
  /** id ЖК **/
  newbuildingId: number;
  /** Пагинация **/
  page?: number | null;
  /** Сортировка **/
  sort?: ESort | null;
}
export enum ESort {
  /** По дате (сначала новые) **/
  'By_date_asc' = 'by_date_asc',
  /** По дате (сначала старые) **/
  'By_date_desc' = 'by_date_desc',
  /** По умолчанию **/
  'Default' = 'default',
}
